import { useEffect, useState } from 'react';
import { getGroupCredentialingEnrollment } from 'api/credentialing';
import { OrgCredentialingEnrollmentVo } from 'types/credentialing';

// Module-level cache so the enrollment (fetched once) persists across mounts and is shared by
// every consumer, matching the pattern in useCredentialInfo. refetch() refreshes it for all.
let globalData: OrgCredentialingEnrollmentVo | null = null;

export const useGroupCredentialingEnrollment = () => {
    const [data, setData] = useState<OrgCredentialingEnrollmentVo | null>(globalData);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await getGroupCredentialingEnrollment();
            if (res && !res.error) {
                globalData = res.data.data;
                setData(res.data.data);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Reuse the cached enrollment when it's already been fetched; only hit the network once.
        if (globalData) {
            setData(globalData);
            return;
        }
        fetchData();
    }, []);

    const refetch = async () => {
        await fetchData();
    };

    return [data, loading, refetch] as const;
};
